export const NewsLetterSubscribe = ({ size = "16" }: { size?: string }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_249_21400)">
      <path
        d="M15.3463 7.16097L14.167 6.03164V2.93164C14.167 1.82897 13.2697 0.931641 12.167 0.931641H4.16699C3.06433 0.931641 2.16699 1.82897 2.16699 2.93164V6.03297L0.988992 7.16097C0.467659 7.66097 0.168326 8.36231 0.168326 9.08564L0.166992 16.9316H16.167V9.08564C16.167 8.36097 15.8677 7.65964 15.3463 7.16097ZM4.16699 2.26497H12.167C12.535 2.26497 12.8337 2.56364 12.8337 2.93164V9.09297L9.58099 12.3456C8.82566 13.101 7.50833 13.101 6.75299 12.3456L3.50033 9.09297V2.93164C3.50033 2.56364 3.79899 2.26497 4.16699 2.26497ZM14.8337 15.5983H1.50033C1.50033 15.5983 1.49766 9.02164 1.50033 8.98964L5.81033 13.2883C6.43899 13.9176 7.27633 14.265 8.16699 14.265C9.05766 14.265 9.89499 13.9176 10.5237 13.2883L14.8337 8.98831C14.8363 9.02097 14.8337 15.5983 14.8337 15.5983ZM6.55766 8.54097L4.70299 6.74364L5.63166 5.78631L7.49366 7.59097L10.701 4.45564L11.6343 5.40764L8.43899 8.54564C8.18166 8.80297 7.84233 8.93164 7.50233 8.93164C7.16233 8.93164 6.81833 8.80164 6.55766 8.54097Z"
        fill="#706A85"
      />
    </g>
    <defs>
      <clipPath id="clip0_249_21400">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0.166992 0.931641)"
        />
      </clipPath>
    </defs>
  </svg>
);
